import { StringMapWithRename } from "@angular/compiler/src/compiler_facade_interface";

export class Client {
  public id: string;
  public name: string;
  public barcode_prefix: string;
  public sector : string;
  public user_id : string;

  public name__icontains: string;
  public barcode_prefix__icontains: string;
  public sector__icontains : string;

  public api_key : string;
  public secret : string;
  public client_id: string;
  public url_cart_validation: string;
  public url_cart_expiration: string;
  public is_wallet: boolean;
  public url_trx_identity: string;
  public url_trx_amount: string;
  public url_trx_confirmation: string;
  public apis: any;
  public client_agg_id: string;
  public is_certificate: boolean;
  public cert_key: any;
  public cert_crt: string;
  public cert_ca: string;
  public send_email: boolean;
  public minimum_amount: number;
}
